

import { Directive, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '../../app.reducer';
import { getAplicacionesUsuarioPorAmbiente, getAmbienteSelecionado } from '../../redux/usuario/usuario.selectors';
import { Aplicacion } from '../../models/usuario.model';
import { Permiso } from '../../modulos/admin/models/permiso';
import { DatePipe } from '@angular/common';

@Directive({
  selector: '[hasDeniedItems]'
})
export class HasDeniedItemsDirective implements OnInit {

  public _idSprAmbiente: number;
  public _itemElemento: number;
  public _tipoElemento: string;
  public _viewOpciones: boolean = false;
  //public _lock: boolean = true;
  elemntosNivelesPermisos: any;
  date = new Date();
  pipe = new DatePipe('en-US');
  private fechaHoy = this.pipe.transform(this.date, 'yyyy-MM-dd');

  @Input() set hasDeniedItems(value: any) {
    this._idSprAmbiente = value.idSprAmbiente;
    this._itemElemento = value.itemElemento;
    this._tipoElemento = value.tipoElemento;
  }

  constructor(
    private store: Store<AppState>,
    private viewContainerRef: ViewContainerRef,
    private templateRef: TemplateRef<any>
  ) { }


  ngOnInit(): void {

    let renderComponent = false;
    this.store.select(getAmbienteSelecionado).subscribe((response) => {
      this.elemntosNivelesPermisos = response
      
    })
    let dataVerifyOpcion: any = [];
    // ########## Opcion para items riesgos  ######################
    if (this._tipoElemento == 'riesgo') {
      dataVerifyOpcion = this.elemntosNivelesPermisos.find(({ idSprRiesgo }) => idSprRiesgo === this._itemElemento);
      
      if (dataVerifyOpcion && dataVerifyOpcion.idSprRiesgo === this._itemElemento && dataVerifyOpcion.idSprAmbiente == this._idSprAmbiente ) {
        
  if(dataVerifyOpcion.fechaInicio <=  this.fechaHoy && dataVerifyOpcion.fechaFin >=  this.fechaHoy ){
 this._viewOpciones = true;
}else{
    this._viewOpciones = false;
  }
}
      
    }
    // ########## Opcion para items indicadores  ######################
    else if (this._tipoElemento == 'indicador') {
      dataVerifyOpcion = this.elemntosNivelesPermisos.find(({ idSprIndicador }) => idSprIndicador === this._itemElemento)  
              if (dataVerifyOpcion && dataVerifyOpcion.idSprIndicador === this._itemElemento && dataVerifyOpcion.idSprAmbiente == this._idSprAmbiente ) {
       
  if(dataVerifyOpcion.fechaInicio <=  this.fechaHoy && dataVerifyOpcion.fechaFin >=  this.fechaHoy ){

    this._viewOpciones = true;
  }else{

    this._viewOpciones = false;
  }
}


    }



    
    
    
    if(this._viewOpciones){
      renderComponent = true;
      // for (let permiso of dataNivelActivo.permisos) {
      //   if (this._permission.find((per)=>per===permiso.idSprPermiso)) {
      //     renderComponent = true;
      //     break;
      //   }
      // }
    }else{
      renderComponent = false;
    }

    if (renderComponent) {
      this.viewContainerRef.createEmbeddedView(this.templateRef)
    } else {
      this.viewContainerRef.clear();
    }
  }
}
